import { Color, Mode, Type } from '@/features/ui/buttons/components/IconButton/types'
import {
    getBackgroundColor,
    getOutlineBorder,
    getShadows,
} from '@/features/ui/buttons/components/IconButton/utils'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { createStyleSheet } from 'react-native-unistyles'

export const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    containerExtra: (
        mode: Mode,
        type: Type,
        state: ButtonStateEnum,
        color: Color,
        size: number
    ) => ({
        backgroundColor: getBackgroundColor(type, state, color),
        borderRadius: mode === 'rounded' ? size / 2 : 4,
        height: size,
        width: size,
        ...(type === 'outline' && getOutlineBorder(state, color)),
        ...(state === ButtonStateEnum.Pressed && getShadows(color)),
    }),
})
